module.exports = __webpack_public_path__ + "fonts/Roboto-Light.370f861.ttf";